import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import './styles.scss'
import '../../styles/index.scss'

class Checkbox extends Component {
  render () {
    const {
      title,
      name,
      value,
      isChecked,
      onChange,
      automationName,
      Store
    } = this.props

    const componentHasError = Store.hasError(name) ? 'has-error' : ''
    const componentClassNames = `checkOne checkbox ${componentHasError}`

    return (
      <div className='checkbox-inline col-md-6 col-xs-12'>
        <div
          data-automation-name={automationName}
          className={componentClassNames}
        >
          <label className='radioLabel'>
            <input
              type='checkbox'
              checked={isChecked}
              name={name}
              value={value}
              onChange={onChange}
              data-automation-name={value}
            />
            <span>&nbsp;{title}</span>
          </label>
        </div>
      </div>
    )
  }
}

Checkbox.propTypes = {
  Store: PropTypes.object.isRequired
}

export default observer(Checkbox)
